/** Keep versions in sync with backend LegalDocuments / *Text classes. */
export const LEGAL_TERMS_VERSION = "1.3";
export const LEGAL_PRIVACY_VERSION = "1.4";
export const LEGAL_EFFECTIVE_DATE = "25 de julho de 2026";
export const LEGAL_SUPPORT_EMAIL = "contato@mivo.digital";
export const LEGAL_PRIVACY_EMAIL = "contato@mivo.digital";

export type LegalSection = {
    title: string;
    paragraphs: string[];
};

export const TERMS_SECTIONS: LegalSection[] = [
    {
        title: "1. Aceitação dos Termos",
        paragraphs: [
            "Ao utilizar o Mivo, o usuário declara que leu, compreendeu e concorda com estes Termos de Uso e com a Política de Privacidade da plataforma.",
        ],
    },
    {
        title: "2. Sobre o Mivo",
        paragraphs: [
            "O Mivo é uma plataforma digital destinada à organização e ao acompanhamento de informações relacionadas ao atendimento terapêutico de pacientes, incluindo registro de evoluções, objetivos, orientações, comunicação entre usuários autorizados, gestão de documentos e mídias, e compartilhamento controlado entre profissionais, pacientes e responsáveis autorizados.",
        ],
    },
    {
        title: "2.1 Disponibilidade da Plataforma",
        paragraphs: [
            "O Mivo busca manter a plataforma disponível de forma contínua e segura. Podem ocorrer interrupções temporárias por manutenção, atualizações, falhas de infraestrutura, serviços de terceiros ou eventos fora do controle da plataforma. O Mivo não garante disponibilidade ininterrupta dos serviços.",
        ],
    },
    {
        title: "3. Natureza da Plataforma",
        paragraphs: [
            "O Mivo é uma ferramenta de apoio à organização terapêutica. Não substitui avaliação profissional, diagnóstico, prescrição ou decisão clínica de profissional habilitado. A responsabilidade pelas informações registradas e pelas decisões terapêuticas permanece com os profissionais envolvidos.",
        ],
    },
    {
        title: "4. Emergências",
        paragraphs: [
            "O Mivo não se destina ao atendimento de emergências. Em situações de urgência, o usuário deve procurar imediatamente os serviços competentes.",
        ],
    },
    {
        title: "5. Cadastro e Acesso",
        paragraphs: [
            "O usuário é responsável pela veracidade das informações fornecidas. O acesso é pessoal e intransferível. O usuário deve manter a confidencialidade de suas credenciais.",
        ],
    },
    {
        title: "5.1 Período de Experimentação (profissionais)",
        paragraphs: [
            "Contas de profissionais iniciam em período de experimentação conforme o plano vigente divulgado na plataforma, com limite de pacientes ativos definido nesse plano. Após o prazo de experimentação contado da criação da conta, o acesso poderá ser bloqueado até a contratação de plano pago, conforme condições divulgadas na plataforma.",
        ],
    },
    {
        title: "6. Compartilhamento de Informações",
        paragraphs: [
            "Informações registradas podem ser compartilhadas entre profissionais autorizados vinculados ao paciente. O profissional responsável define quais informações ficam disponíveis ao paciente e aos responsáveis vinculados.",
        ],
    },
    {
        title: "7. Tratamento de Dados",
        paragraphs: [
            "Em regra, o profissional que atende o paciente é o controlador dos dados clínicos; o Mivo é o operador da plataforma tecnológica.",
            "Enquanto houver vínculo ativo entre você e o profissional, os dados do paciente permanecem acessíveis conforme as permissões da plataforma.",
            "Após o encerramento do vínculo com um profissional, poderão ser mantidos acessos residuais ao histórico do atendimento, observadas as permissões aplicáveis, pelo período necessário ao cumprimento de obrigações legais, regulatórias, éticas e ao exercício regular de direitos relacionados à prestação dos serviços.",
            "Decorridos os prazos de retenção aplicáveis, os dados pessoais e arquivos associados poderão ser excluídos ou anonimizados, conforme critérios técnicos, operacionais e legais adotados pela plataforma.",
            "O Mivo poderá manter registros mínimos necessários ao cumprimento de obrigações legais e regulatórias, ao exercício regular de direitos, à auditoria, à segurança da informação e à comprovação dos consentimentos concedidos pelos usuários.",
        ],
    },
    {
        title: "8. Uso de Recursos Tecnológicos e Inteligência Artificial",
        paragraphs: [
            "O Mivo poderá disponibilizar recursos auxiliares, inclusive baseados em inteligência artificial, quando oferecidos na plataforma. Tais recursos são exclusivamente auxiliares, exigem revisão e validação humana pelos profissionais, e não substituem decisões clínicas. Nenhuma decisão clínica será tomada automaticamente pela plataforma.",
            "O usuário declara possuir os direitos, autorizações e bases legais necessárias para inserir na plataforma dados pessoais, documentos, fotografias, vídeos e demais conteúdos relacionados aos pacientes atendidos.",
        ],
    },
    {
        title: "9. Conteúdo Inserido pelos Usuários",
        paragraphs: [
            "Os usuários são responsáveis pela legalidade, veracidade e adequação das informações inseridas. O Mivo atua como ferramenta tecnológica de apoio à organização das informações inseridas na plataforma.",
            "O Mivo adota medidas técnicas e administrativas compatíveis com boas práticas de mercado. Nenhum sistema é totalmente imune a falhas ou incidentes de segurança.",
        ],
    },
    {
        title: "10. Suspensão ou Encerramento de Contas",
        paragraphs: [
            "O Mivo poderá suspender ou encerrar contas em caso de uso ilícito, comprometimento da segurança, descumprimento destes Termos, expiração do período de experimentação sem plano pago, ou outras hipóteses previstas na Política de Privacidade e na legislação aplicável.",
        ],
    },
    {
        title: "11. Alterações dos Termos",
        paragraphs: [
            "Estes Termos poderão ser atualizados. Alterações relevantes poderão exigir novo aceite antes do uso continuado da plataforma.",
        ],
    },
    {
        title: "12. Propriedade e Licença de Uso",
        paragraphs: [
            "O Mivo concede licença limitada, não exclusiva, revogável e intransferível para uso da plataforma conforme sua finalidade. Nenhuma disposição transfere direitos de propriedade intelectual sobre o software, marca ou funcionalidades do Mivo.",
        ],
    },
    {
        title: "13. Contato",
        paragraphs: [`Dúvidas sobre estes Termos: ${LEGAL_SUPPORT_EMAIL}`],
    },
];

export const PRIVACY_SECTIONS: LegalSection[] = [
    {
        title: "1. Objetivo",
        paragraphs: [
            "Esta Política descreve como o Mivo coleta, utiliza, armazena, compartilha e protege dados pessoais, inclusive dados sensíveis relacionados à saúde, quando aplicável.",
        ],
    },
    {
        title: "1.1 Papel no Tratamento de Dados",
        paragraphs: [
            "Os profissionais que utilizam a plataforma são, em regra, controladores das informações clínicas de seus pacientes, nos termos da LGPD. O Mivo atua como operador da plataforma tecnológica, tratando dados conforme instruções dos profissionais e para prestação dos serviços.",
            `Dúvidas relacionadas ao tratamento de dados de um atendimento específico deverão ser direcionadas ao profissional responsável pelo atendimento. Sobre a plataforma: ${LEGAL_SUPPORT_EMAIL}`,
        ],
    },
    {
        title: "2. Dados Coletados",
        paragraphs: [
            "Dados cadastrais, dados de pacientes e responsáveis, dados terapêuticos, arquivos enviados (fotos, vídeos, documentos), dados de comunicação, identificadores técnicos (IP, logs, dispositivo), dados de login social quando utilizado e, quando você autorizar, dados de usuário do Google conforme a seção 12 desta Política.",
        ],
    },
    {
        title: "3. Finalidades",
        paragraphs: [
            "Prestação dos serviços, organização do acompanhamento terapêutico, compartilhamento entre usuários autorizados, segurança, cumprimento legal, auditoria de aceites e, quando disponibilizados, funcionalidades auxiliares de inteligência artificial com revisão humana.",
        ],
    },
    {
        title: "4. Compartilhamento",
        paragraphs: [
            "Entre profissionais e responsáveis vinculados ao paciente conforme permissões; com fornecedores tecnológicos necessários ao funcionamento; quando exigido por lei. O Mivo não comercializa dados pessoais.",
        ],
    },
    {
        title: "5. Inteligência Artificial",
        paragraphs: [
            "Recursos de IA, quando disponibilizados, têm caráter auxiliar. Não substituem avaliação humana. Não há decisão clínica automatizada.",
        ],
    },
    {
        title: "6. Segurança",
        paragraphs: [
            "Medidas técnicas e administrativas contra acesso não autorizado, perda, alteração ou divulgação indevida, sem eliminação total de riscos inerentes ao ambiente digital.",
        ],
    },
    {
        title: "7. Direitos dos Titulares",
        paragraphs: [
            "Nos termos da LGPD: confirmação, acesso, correção, portabilidade quando aplicável, informação sobre compartilhamentos, revogação de consentimento quando cabível e eliminação quando legalmente possível.",
        ],
    },
    {
        title: "8. Retenção de Dados",
        paragraphs: [
            "Após o encerramento do vínculo com um profissional, o responsável poderá manter acesso em modo somente leitura aos dados daquele atendimento pelo período definido pela plataforma.",
            "O profissional poderá manter acesso ao histórico do atendimento pelo período necessário ao cumprimento de obrigações legais, regulatórias, éticas e ao exercício regular de direitos relacionados à prestação dos serviços.",
            "Decorridos os prazos de retenção aplicáveis, os dados pessoais e arquivos associados poderão ser excluídos ou anonimizados, conforme critérios técnicos, operacionais e legais adotados pela plataforma.",
            "O Mivo poderá manter registros mínimos necessários ao cumprimento de obrigações legais e regulatórias, ao exercício regular de direitos, à auditoria, à segurança da informação e à comprovação dos consentimentos concedidos pelos usuários.",
        ],
    },
    {
        title: "8.1 Exclusão de Conta",
        paragraphs: [
            "O usuário pode solicitar o encerramento da conta. O acesso é encerrado; determinados dados poderão ser mantidos pelo período necessário ao cumprimento de obrigações legais, regulatórias, contratuais, ao exercício regular de direitos e à preservação da integridade dos registros relacionados aos serviços prestados.",
        ],
    },
    {
        title: "9. Registro de Aceites",
        paragraphs: [
            "O Mivo registra data, hora, IP, identificação do usuário, versão dos documentos aceitos e hash para auditoria e comprovação legal.",
        ],
    },
    {
        title: "10. Menores de Idade",
        paragraphs: [
            "Quando o paciente for menor ou legalmente incapaz, os dados são gerenciados pelo responsável legal, que declara possuir poderes para representá-lo.",
        ],
    },
    {
        title: "11. Alterações",
        paragraphs: ["Esta Política pode ser atualizada. Alterações relevantes podem exigir novo aceite."],
    },
    {
        title: "12. Dados de usuário do Google",
        paragraphs: [
            "O Mivo utiliza Google API Services de duas formas opcionais, somente com sua autorização: (a) login ou cadastro com Google Sign-In; e (b) integração com Google Agenda nas configurações da conta, para exportar sessões agendadas na plataforma para um calendário Google escolhido por você.",
            "Dados do Google acessados no login com Google: identificador da conta Google (sub), endereço de e-mail, nome de exibição e, quando fornecido pelo Google, indicação de verificação do e-mail. Esses dados são usados exclusivamente para autenticar você, criar ou vincular sua conta Mivo e preencher seu nome no cadastro quando aplicável.",
            "Dados do Google acessados na integração com Google Agenda: endereço de e-mail da conta Google conectada; lista de calendários nos quais você tem permissão de escrita (identificador, nome e indicação de calendário principal), para que você escolha o destino da sincronização; e criação, atualização ou exclusão de eventos apenas no calendário selecionado e somente para sessões agendadas no Mivo que você tem permissão de visualizar. Os eventos exportados podem conter título (nome do paciente ou do profissional), data e horário de início e fim, fuso horário e, para profissionais, link interno para o registro do paciente na plataforma. O Mivo não lê nem armazena outros eventos do seu Google Agenda, exceto os identificadores dos eventos criados pela própria integração para manter a sincronização.",
            "Armazenamento: no login social, guardamos o identificador Google vinculado à sua conta Mivo. Na integração com agenda, armazenamos o e-mail Google conectado, o calendário escolhido, tokens OAuth (incluindo refresh token) com proteção criptográfica, o mapeamento entre sessões do Mivo e identificadores de eventos no Google, e metadados de sincronização (por exemplo, data da última sincronização e mensagens de erro).",
            "Compartilhamento: os dados do Google são transmitidos apenas ao Google para executar autenticação e chamadas à API do Google Agenda, e aos provedores de infraestrutura que hospedam a plataforma sob obrigações contratuais de confidencialidade e segurança. O Mivo não vende dados de usuários do Google, não os utiliza para publicidade nem os compartilha com corretores de dados.",
            "Controle e revogação: você pode desconectar o Google Agenda nas configurações da conta (o que remove os tokens armazenados e tenta excluir os eventos sincronizados pelo Mivo), revogar o acesso do Mivo em https://myaccount.google.com/permissions e deixar de usar o login com Google, mantendo acesso por e-mail e senha quando disponível.",
            "Retenção e exclusão dos dados da integração Google Agenda: ao desconectar a agenda, ao confirmar desativação da conta ou quando a exclusão da conta for concluída conforme as regras da plataforma, removemos o vínculo da conexão, os tokens OAuth armazenados, o calendário escolhido, o mapeamento sessão-evento e os metadados de sincronização associados; também tentamos revogar o token junto ao Google e excluir os eventos criados pelo Mivo no calendário de destino. Dados de login social (identificador Google vinculado à conta Mivo) seguem as regras gerais de retenção e exclusão de conta desta Política.",
            "Inteligência artificial: dados brutos ou derivados obtidos das APIs do Google Agenda e do userinfo usados na integração de agenda (incluindo e-mail conectado, lista de calendários e conteúdo dos eventos exportados) não são utilizados para desenvolver, melhorar ou treinar modelos de IA/ML, nem são transferidos a serviços de terceiros de IA/ML para treinamento. Recursos de IA eventualmente disponíveis no Mivo não utilizam esses dados de usuário do Google Agenda para treinar modelos.",
            "Uso limitado: o uso de informações recebidas das APIs do Google está em conformidade com a Google API Services User Data Policy, incluindo os requisitos de Limited Use — os dados são usados somente para oferecer os recursos de login e sincronização de agenda visíveis na interface do Mivo; não são transferidos para terceiros exceto conforme permitido por essa política; e não são usados para veiculação de anúncios.",
        ],
    },
    {
        title: "13. Contato",
        paragraphs: [`Se você tiver dúvidas sobre a Política de Privacidade: ${LEGAL_PRIVACY_EMAIL}`],
    },
];

export const THERAPIST_ROLE_DECLARATION =
    "Declaro ser profissional habilitado na área informada no cadastro e assumir a responsabilidade pelas informações clínicas que inserir na plataforma, inclusive quanto ao tratamento de dados pessoais e sensíveis dos pacientes sob minha responsabilidade, nos termos da legislação aplicável.";

export const PARENT_ROLE_DECLARATION =
    "Declaro ser responsável legal pelo paciente vinculado à minha conta, quando aplicável, e possuir poderes para fornecer e gerenciar seus dados na plataforma, nos termos da legislação aplicável.";

export const SECRETARY_ROLE_DECLARATION =
    "Declaro que atuo como membro do time administrativo do profissional que me convidou, com acesso limitado às permissões concedidas por ele na plataforma.";

export const CLINIC_MANAGER_ROLE_DECLARATION =
    "Declaro ser o responsável legal pela clínica cadastrada e assumir a responsabilidade pelo uso da plataforma em nome da equipe, inclusive quanto ao tratamento de dados pessoais e sensíveis dos pacientes atendidos pela clínica, nos termos da legislação aplicável.";

